import { render, staticRenderFns } from "./schooldistance.vue.js?vue&type=template&id=35b44b13!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./schooldistance.vue?vue&type=template&id=35b44b13"
import script from "./schooldistance.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./schooldistance.vue?vue&type=script&lang=js"
export * from "./schooldistance.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./schooldistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports